import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
import "./styles.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export interface DialogProps {
  show: boolean;
  data: PrivacyPolicyContent;
  hideFooter?: boolean;
  onClose: (show: boolean) => void;
  onContinue: () => void;
}

export type PrivacyPolicyContent = {
  body: string;
  title: string;
  cancel: string;
  accept: string;
};

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other} className="backgroundAzul">
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function PrivacyPolicyDialog(props: DialogProps) {
  console.log(props);
  const handleClose = () => {
    props.onClose(false);
  };

  const handleContinue = () => {
    props.onContinue();
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.show}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {props.data.title}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography className="privacyPolicyTitle" gutterBottom>
            {Parser().parse(sanitizeHtml(props.data.body))}
          </Typography>
        </DialogContent>
        {props.hideFooter !==true &&
        <DialogActions className="backgroundAzul">
          <Button autoFocus onClick={handleClose}>
            {props.data.cancel}
          </Button>
          <Button autoFocus onClick={handleContinue}>
            {props.data.accept}
          </Button>
        </DialogActions>
}
      </BootstrapDialog>
    </div>
  );
}
